// if(document.querySelector('.tooltipster')){
//     const $page = document.querySelector('.page');
//     $page.addEventListener('click', e => {
//         const $tooltip = document.querySelector('.tooltipster'); 
//         if(e.target.classList.contains('tooltipster')){
//             $tooltip.classList.toggle('tooltipster--active')
//         } else {
//             $tooltip.classList.remove('tooltipster--active')
//         }
//     })
// }
